import type { FC } from 'react';
import { NavigationControl as RawNavigationControl } from 'react-map-gl/mapbox';

export const NavigationControl: FC = () => {
  return <RawNavigationControl style={{ position: 'unset' }} />;
};
